/* eslint-disable jira/filename-case */
export const PACKAGE_NAME = 'jiraRouterResourcesGrowthRecommendations';
